import axios from "axios";
import { logDev } from "../utils/logger.js"

export const createItemRowUpdate = (groupeId, setRows, refreshRows) => {
  return async (newRow, oldRow) => {
    // Trouver la colonne modifiée (celle qui commence par "contact_")
    const changedField = Object.keys(newRow).find(
      key => newRow[key] !== oldRow[key] && key.startsWith("contact_")
    );

    if (!changedField) {
      return oldRow; // rien n’a changé
    }

    // Extraire le vrai contactId
    const contactId = changedField.replace("contact_", "");
    const value = Number(newRow[changedField] || 0);

    // 🚨 Vérification : si l’item n’a pas encore de vrai _id Mongo, on bloque
    if (!newRow._id || newRow._id.startsWith("menu_") || newRow._id.startsWith("custom_")) {
        logDev("[createItemRowUpdate] saisie ignorée (pas d'_id Mongo)", newRow);
        return oldRow; // rollback → on ne tente pas l’appel API
    }

    const payload = {
      groupeId,
      item: newRow._id, // l’ID de l’item
      values: [{ contactId, value }]
    };

    try {
      logDev("[createItemRowUpdate] payload envoyé à /saisie", payload);
      await axios.post(`${process.env.REACT_APP_API}/saisie`, payload);
     
      // ✅ Recharger les rows pour recalculer les totaux et les couleurs
      if (refreshRows) refreshRows();

      return newRow;
    } catch (err) {
      logDev("[createItemRowUpdate] erreur enregistrement saisie", err);
      return oldRow; // rollback
    }
  };
};
